var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "_dots", attrs: { role: "progressbar" } },
    _vm._l(3, function(i) {
      return _c("svg", { attrs: { viewBox: "0 0 2 2" } }, [
        _c("circle", { attrs: { cx: "1", cy: "1", r: "1" } })
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }